import { Typography } from "@mui/material";
import theme from "../../muiTheme";
import "./SuppliesBillsStateContent.scss";
import { useTranslation } from "react-i18next";
import {
  MANAGEMENTS_STATE_RESOLVED,
  MANAGEMENTS_STATE_PENDING,
  MANAGEMENTS_STATE_REJECTED,
  MANAGEMENTS_STATE_OPEN,
  MANAGEMENTS_STATE_PENDING_DISTRIBUTION,
  MANAGEMENTS_STATE_PENDING_COMMERCIAL,
  MANAGEMENTS_STATE_PENDING_CLIENT,
  MANAGEMENTS_STATE_UNSOLVED,
} from "../../core/constants/constants";
import { ManagementsStateData } from "../../core/models/managements/managements.model";

export interface SuppliesBillsStateContentProps {
  state: string;
  formatText?: (text: string) => ManagementsStateData;
}

const SuppliesBillsStateContent = ({
  state,
  formatText,
}: SuppliesBillsStateContentProps) => {
  const { t } = useTranslation();

  const formatState = (text: string) => {
    if (isNaN(+text)) {
      return t(`Gestiones.Estados.${state}`);
    }

    return formatText && t(formatText(text).label);
  };

  const stateContent = () => {
    switch (state) {
      case MANAGEMENTS_STATE_RESOLVED:
      case MANAGEMENTS_STATE_UNSOLVED:
      case "true":
      case "Vigente":
      case "Pagado":
        return {
          classNameIcon: "t-icon-check",
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.contrastText,
          text: state === "true" ? "Pagado" : formatState(state),
        };
      case MANAGEMENTS_STATE_PENDING:
      case MANAGEMENTS_STATE_OPEN:
      case MANAGEMENTS_STATE_PENDING_DISTRIBUTION:
      case MANAGEMENTS_STATE_PENDING_COMMERCIAL:
      case MANAGEMENTS_STATE_PENDING_CLIENT:
      case "false":
      case "Pendiente":
        return {
          classNameIcon: "t-icon-clock",
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.contrastText,
          text: state === "false" ? "Pendiente" : formatState(state),
        };

      case MANAGEMENTS_STATE_REJECTED:
      case "No vigente":
      case "Rechazado":
      case "No pagado":
        return {
          classNameIcon: "t-icon-close",
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.contrastText,
          text: formatState(state),
        };
      default:
        return { classNameIcon: "", backgroundColor: "", color: "", text: "" };
    }
  };

  const { classNameIcon, backgroundColor, color, text } = stateContent();

  return (
    <Typography
      variant="body1"
      component="span"
      width={"fit-content"}
      sx={{
        backgroundColor: backgroundColor,
        color: color,
        // whiteSpace: "nowrap",
      }}
      className="state-chip"
    >
      <span aria-hidden="true" className={classNameIcon} /> {text}
    </Typography>
  );
};

export default SuppliesBillsStateContent;
